import React from 'react'

export default function DeleteIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        xmlns='http://www.w3.org/2000/svg'
        id='delete_2'
        d='M3.89994 11.6809C3.61392 11.6809 3.36907 11.579 3.16539 11.3754C2.96171 11.1717 2.85988 10.9268 2.85988 10.6408V3.88041H2.33984V2.84034H4.94V2.32031H8.06019V2.84034H10.6603V3.88041H10.1403V10.6408C10.1403 10.9268 10.0385 11.1717 9.83479 11.3754C9.63112 11.579 9.38627 11.6809 9.10025 11.6809H3.89994ZM4.94 9.60075H5.98006V4.92047H4.94V9.60075ZM7.02013 9.60075H8.06019V4.92047H7.02013V9.60075Z'
        fill='currentColor'
      />
    </svg>
  )
}
